import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

function Address() {
  const { t } = useTranslation();

  return (
   <div>	
  <main className="page-content page-content-ones">
    <div className="tm-section tm-my-account-area bg-white tm-padding-section wishlist-section-ones">
      <div className="container">
        <div className="tm-myaccount">
          <div className="tab-content" id="account-ontent">
            <div className="tab-pane fade show active" id="account-dashboard" role="tabpanel" aria-labelledby="account-dashboard-tab">
              <div className="tm-myaccount-dashboard1">
                <div className="cart-box-two">
                  <div className="row">
                    <div className="col-lg-8 col-md-6">
                      <div className="my-wishlist my-wishlist-one contact-form">
                        <h4>{t("A1")}</h4>
                      </div>
                      {/* <div class="cart-box1 cart-box11 contact-form">
                                      <div class="row">
                                          <div class="col-lg-12">
                                              <div class="cart-text cart-text1 cart-text12">
                                                  <form class="full-form">
                                                      <h2><span> Contact Details</span></h2>
                                                      <div class="row">
                                                          <div class="col-lg-6 col-md-6">
                                                              <input class="card-form" type="text" placeholder="Name*">
                                                          </div>
                                                          <div class="col-lg-6 col-md-6">
                                                              <input class="card-form" type="text" placeholder="Mobile No*">
                                                          </div>
                                                      </div>
                                                      <h2><span> ADDRESS</span></h2>
                                                      <div class="row">
                                                          <div class="col-lg-6 col-md-6">
                                                              <input class="card-form" type="text" placeholder="Pin Code*">
                                                          </div>
                                                          <div class="col-lg-6 col-md-6">
                                                              <input class="card-form" type="text" placeholder="Address (House No, Building, Street, Area)*">
                                                          </div>
                                                          <div class="col-lg-12 col-md-6">
                                                              <input class="card-form" type="text" placeholder="Locality / Town*">
                                                          </div>
                                                      </div>
                                                      <div class="form-twobutton">
                                                          <div class="form-left">
                                                              <label>City / District*</label>
                                                          </div>
                                                          <div class="form-left">
                                                              <label>State*</label>
                                                          </div>
                                                      </div>
                                                      <h2><span> SAVE ADDRESS AS</span></h2>
                                                      <div class="address-btn">
                                                          <div class="address-btn1">
                                                              Home
                                                          </div>
                                                          <div class="address-btn1">
                                                              Work
                                                          </div>
                                                      </div><br>
                                                      <div class="check-boxbtn">
                                                          <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike">
                                                          <label for="vehicle1"> Make this my default address</label>
                                                      </div>
                                                      <button class="add-men-btn">ADD ADDRESS</button>
                                                  </form>
                                              </div>
                                          </div>
                                      </div>
                                  </div> */}
                      <div className="cart-box1 cart-box11 cart-box12">
                        <div className="delivery-address-menBox">
                          <h5 className="modal-title mb-2" id="exampleModalLabel">{t("A2")}</h5>
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="form-check form-check-one">
                                <label className="form-check-label form-check-label-one w-100" htmlFor="flexRadioDefault1" style={{color: '#ae4b84'}}>{t("A3")}<span className="float-end"><i className="fa-solid fa fa-briefcase fa-lg" /> {t("A4")}</span> </label>
                                <div className="address-box1">
                                  <h2>+91-9999999999</h2>
                                  <p>{t("A5")}</p>
                                </div>
                                <div id="radios" className="mt-2">
                                  <label htmlFor="address2" className="material-icons m-0">
                                    <input type="radio" name="address_id" id="address2" defaultValue={1} defaultChecked />
                                    <span className="address-btn1 setDeliverHere" data-id={2}><i className="fa-solid fa fa-check-circle fa-lg" /> {t("A6")}</span>
                                  </label>     
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="cart-box1 cart-box11">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="cart-text cart-text1 cart-text12">
                              <button type="button" className="tm-button tm-button22 tm-button-dark" data-bs-toggle="modal" data-bs-target="#exampleModal">
                              {t("A7")}
                              </button>
                              {/* Modal */}
                              <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-scrollable">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title" id="exampleModalLabel">{t("A8")}</h5>
                                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                    </div>
                                    <div className="modal-body">
                                      <div className="cart-box1 cart-box11">
                                        <div className="row">
                                          <div className="col-lg-12">
                                            <div className="cart-box5">
                                              <div className="row">
                                                <div className="col-lg-12">
                                                  <div className="cart-text cart-text1 cart-text12">
                                                    <form className="full-form">
                                                      <h2><span> {t("A9")}</span></h2>
                                                      <div className="row">
                                                        <div className="col-lg-12 col-md-6">
                                                          <input className="card-form" type="text" placeholder={t("A28")} />
                                                        </div>
                                                        <div className="col-lg-12 col-md-6">
                                                          <input className="card-form" type="text" placeholder={t("A29")} />
                                                        </div>
                                                      </div>
                                                      <h2><span> {t("A10")}</span></h2>
                                                      <div className="row">
                                                        <div className="col-lg-12 col-md-6">
                                                          <input className="card-form" type="text" placeholder={t("A30")}  />
                                                        </div>
                                                        <div className="col-lg-12 col-md-6">
                                                          <input className="card-form" type="text" placeholder={t("A31")}  />
                                                        </div>
                                                        <div className="col-lg-12 col-md-6">
                                                          <input className="card-form" type="text" placeholder={t("A32")}  />
                                                        </div>
                                                      </div>
                                                      <div className="form-twobutton">
                                                        <div className="form-left">
                                                          <label>{t("A11")}</label>
                                                        </div>
                                                        <div className="form-left">
                                                          <label>{t("A12")}</label>
                                                        </div>
                                                      </div>
                                                      <h2><span> {t("A13")}</span></h2>
                                                      <div className="address-btn">
                                                        <div className="address-btn1">
                                                        {t("A14")}
                                                        </div>
                                                        <div className="address-btn1">
                                                        {t("A15")}
                                                        </div>
                                                      </div><br />
                                                      <div className="check-boxbtn check-boxbtn-aa">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" defaultValue="Bike" />
                                                        <label htmlFor="vehicle1"> {t("A16")}</label>
                                                      </div>
                                                    </form>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="cart-text cart-text1 cart-text12">
                                        <a href="#">
                                          <div className="add-new-address add-new-address11 text-center">{t("A17")}</div>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* Modal */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 ">
                      <div className="my-wishlist my-wishlist-one">
                        <h4>{t("A18")}</h4>
                      </div>
                      <div className="cart-right">
                        <div className="my-wishlist my-wishlist-one">
                          <h4>{t("A19")}</h4>
                        </div>
                        <div className="cart-box2">
                          <div className="row">
                            <div className="col-lg-6 col-6">
                              <div className="two-left">
                                <h2>{t("A20")}</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right">
                                <h2>+ ₹460</h2>
                              </div>
                            </div>
                          </div>
                          <div className="row card-right-center">
                            <div className="col-lg-6 col-6">
                              <div className="two-left">
                                <h2>{t("A21")}</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right">
                                <h2 className="discount-text">- ₹49</h2>
                              </div>
                            </div>
                          </div>
                          <div className="row card-right-center">
                            <div className="col-lg-6 col-6">
                              <div className="two-left">
                                <h2>{t("A22")}</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right">
                                <h2>{t("C7")}</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="cart-box3">
                          <div className="row card-right-center">
                            <div className="col-lg-6 col-6">
                              <div className="two-left two-left1">
                                <h2>{t("C17")}</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right two-right1">
                                <h2>₹411</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="cart-box3">
                          <form className="full-form"><br />
                            <div className="my-wishlist my-wishlist-one">
                              <h4>{t("A23")}</h4>
                            </div>
                            <h2><span> </span></h2>
                            <div className="payment-last">
                              <div className="form-check">
                                <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" defaultValue="option1" defaultChecked />
                                <label className="form-check-label" htmlFor="exampleRadios1">
                                {t("A24")}
                                </label>
                                <span><img src="assets/images/pay1-icon.png" /></span>
                              </div>
                              <div className="form-check">
                                <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" defaultValue="option2" />
                                <label className="form-check-label" htmlFor="exampleRadios2">
                                {t("A25")}
                                </label>
                                <span className="pay-icon"><img src="assets/images/pay2-icon.png" /></span>
                              </div>
                              <div className="form-check">
                                <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" defaultValue="option2" />
                                <label className="form-check-label" htmlFor="exampleRadios3">
                                {t("A26")}
                                </label>
                                <span className="pay-icon1"><img src="assets/images/pay3-icon.png" /></span>
                              </div>
                            </div>
                            <Link to ="/Thanks" className="tm-button tm-button22 tm-button-dark">{t("A27")}</Link>
                          </form>
                        </div>
                        {/* <div class="cart-box4">
                                          <div class="row card-right-center">
                                              <div class="col-lg-12">
                                                  <div class="two-left two-left1">
                                                      <p>Clicking on ‘Continue’ will not deduct any money</p>
                                                      <a href="payment.html"><h2>Continue</h2></a>
                                                  </div>
                                              </div>
                                          </div>
                                      </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="account-orders" role="tabpanel" aria-labelledby="account-orders-tab">
              <div className="tm-myaccount-orders">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead>
                    <tr>
                        <th className="tm-myaccount-orders-col-id">{t("C20")}</th>
                        <th className="tm-myaccount-orders-col-date">{t("C21")}</th>
                        <th className="tm-myaccount-orders-col-status">{t("C22")}</th>
                        <th className="tm-myaccount-orders-col-total">{t("C23")}</th>
                        <th className="tm-myaccount-orders-col-view">{t("C24")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>#12345</td>
                        <td>{t("C25")}</td>
                        <td>{t("C26")}</td>
                        <td>{t("C27")}</td>
                        <td><a href="#" className="tm-button tm-button-small">View</a>
                        </td>
                      </tr>
                      <tr>
                        <td>#12346</td>
                        <td>{t("C25")}</td>
                        <td>{t("C26")}</td>
                        <td>{t("C28")}</td>
                        <td><a href="#" className="tm-button tm-button-small">View</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="account-address" role="tabpanel" aria-labelledby="account-address-tab">
              <div className="tm-myaccount-address">
              <p><b>{t("C29")}</b></p>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="tm-myaccount-address-billing">
                      <a href="#" className="edit-button">Edit</a>
                      <h3>{t("C30")}</h3>
                      <address>
                      {t("C31")}<br />
                      {t("C32")}<br />
                      {t("C33")}<br />
                      {t("C34")}<br />
                      {t("C35")}
                      </address>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mt-30 mt-md-0">
                    <div className="tm-myaccount-address-shipping">
                      <a href="#" className="edit-button">Edit</a>
                      <h3>{t("C37")}</h3>
                      <address>
                      {t("C31")}<br />
                      {t("C32")}<br />
                      {t("C33")}<br />
                      {t("C34")}<br />
                      {t("C35")}
                      </address>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="account-acdetails" role="tabpanel" aria-labelledby="account-acdetails-tab">
              <div className="tm-myaccount-acdetails">
                <form action="#" className="tm-form tm-form-bordered">
                <h4>{t("C38")}</h4>
                <div className="tm-form-inner">
                    <div className="tm-form-field tm-form-fieldhalf">
                      <label htmlFor="acdetails-firstname">{t("C39")}</label>
                      <input type="text" id="acdetails-firstname" />
                    </div>
                    <div className="tm-form-field tm-form-fieldhalf">
                      <label htmlFor="acdetails-lastname">{t("C40")}</label>
                      <input type="text" id="acdetails-lastname" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-displayname">{t("C41")}</label>
                      <input type="text" id="acdetails-displayname" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-email">{t("C42")}</label>
                      <input type="email" id="acdetails-email" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-password">{t("C43")}</label>
                      <input type="password" id="acdetails-password" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-newpassword">{t("C44")}</label>
                      <input type="password" id="acdetails-newpassword" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-confirmpass">{t("C45")}</label>
                      <input type="password" id="acdetails-confirmpass" />
                    </div>
                    <div className="tm-form-field">
                      <input type="checkbox" name="acdetails-agreeterms" id="acdetails-agreeterms" />
                      <label htmlFor="acdetails-agreeterms">{t("C46")}</label>
                    </div>
                    <div className="tm-form-field">
                      <button type="submit" className="tm-button">{t("C47")}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main></div>

  )
}

export default Address